import React, { FC } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import AlarmOn from '@mui/icons-material/AlarmOn';
import ManualIcon from '@mui/icons-material/Create';
import DownloadedIcon from '@mui/icons-material/AccountBalance';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import QTip from 'components/QuickenControls/QTip';

import { getTxnStateInfo } from 'data/transactions/utils';

import { RegListItem, styles } from '../styles';

import type { AttributesType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface MatchFieldProps {
  attributes: AttributesType;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
}

const MatchField: FC<MatchFieldProps> = ({
  attributes,
  SHOW_ALL,
  txn,
}) => {

  const { classes } = useStyles();

  const renderMatchState = () => {
    let txnState = getTxnStateInfo(txn).entry;
    if (txnState === 'scheduled') {
      txnState = 'blank';
    }
    switch (txnState) {
      case 'bank':
        return (
          // @ts-expect-error: missing props
          <QTip
            title="Bank downloaded transaction"
            wrapId={`${txn.id}-match`}
          >
            <DownloadedIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'manual':
        return (
          // @ts-expect-error: missing props
          <QTip
            title="Manually entered transaction"
            wrapId={`${txn.id}-match`}
          >
            <ManualIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'matched':
        return (
          // @ts-expect-error: missing props
          <QTip
            title="Matched transaction"
            wrapId={`${txn.id}-match`}
          >
            <DownloadedIcon
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      case 'scheduled':
        return (
          // @ts-expect-error: missing props
          <QTip
            title="Scheduled transaction"
            wrapId={`${txn.id}-match`}
          >
            <AlarmOn
              className={classNames(classes.matchStateIcon, txnState)}
            />
          </QTip>
        );
      default:
        return '';
    }
  };

  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={null}
      className={classNames(classes.iconColumn, 'nopoint')}
    >
      {SHOW_ALL && renderMatchState()}
    </RegListItem>
  );
};

export default MatchField;
